import { Component, inject, OnInit, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { selectBudgetById, selectLoading, selectPending } from '../../../../store/selectors/civic-budget.selectors';
import { ContentComponent } from '../../../../components/content/content.component';
import { BreadcrumbsComponent } from '../../../../common/breadcrumbs/breadcrumbs.component';
import { SpinnerComponent } from '../../../../common/spinner/spinner.component';
import { loadBudgets } from '../../../../store/actions/civic-budget.actions';
import { LabelComponent } from '../../../../common/label/label.component';
import { CivicBudgetListItem } from '../../../../services/civic-budget.common.model';
import { AlertComponent } from '../../../../common/alert/alert.component';
import { SessionService } from '../../../../services/ssession.service';
import { AlertContainerComponent, AlertService } from '../../../../common/alert-container/alert-container.component';

@Component({
  selector: 'app-civic-budget-details-page',
  standalone: true,
  imports: [
    ContentComponent,
    BreadcrumbsComponent,
    RouterLink,
    SpinnerComponent,
    LabelComponent,
    AlertComponent,
    AlertContainerComponent
  ],
  templateUrl: './civic-budget-details-page.component.html'
})
export class CivicBudgetDetailsPageComponent implements OnInit {

  private store$: Store = inject(Store);

  private route: ActivatedRoute = inject(ActivatedRoute);

  private alertService: AlertService = inject(AlertService);

  private budgetId: string = this.route.snapshot.params['id'];

  public budget: Signal<CivicBudgetListItem | null> = this.store$.selectSignal(selectBudgetById(this.budgetId));

  public authed: boolean = SessionService.Authed();

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public ngOnInit(): void {
    if (history.state?.message) {
      this.alertService.show({
        type: 'success',
        title: 'Sukces!',
        content: history.state.message
      });
    }
    if (history.state?.error) {
      this.alertService.show({
        type: 'danger',
        title: 'Błąd!',
        content: history.state.error
      });
    }
    this.store$.dispatch(loadBudgets({}));
  }
}
